// action types
const TYPES = {
    SET_AUTH: 'SET_AUTH', // 用户认证信息
    SET_TOKEN: 'SET_TOKEN', //设置token
    UPDATE_USER_INFO: 'UPDATE_USER_INFO', //更新用户信息 eg:用户名称,头像
    CONFIG_INFO: 'CONFIG_INFO', //后端传回的配置信息
    LOGIN_STATUS: 'LOGIN_STATUS', //是否login ,存在login是要在获取到token之后才算登录过了
    USER_SUBSCRIBE: 'USER_SUBSCRIBE', //订阅消息模板
    LOGIN_FAILE: 'LOGIN_FAILE', //登录失败
	USER_SETTING: 'USER_SETTING', //用户系统设置
};

// initial state
const state = {
    user: {
        uid:'',
        token:'',
		setMeal:'',
		wechatType:'',
    },
    isVersion: false,
    loginStatus: false,
    userSetting: {},
    subscribe: {},
    launch:{},
    loginFaile: false, //登录是否失败
};

// getters
const getters = {
    currentUser(state) {
        return state.user;
    }
};

// actions
const actions = {

    //更新用户信息
    updateUserinfo({
        commit
    }, user = {}) {
		let data = {
			...state.user,
			...user
		}
		// console.log(111,user,data)
        commit(TYPES.UPDATE_USER_INFO, data);
    },
    //更新手机
    upPhone({
        commit
    }, data = {}) {
        commit(TYPES.UPPHONE,data);
    },
    //更新Launch
    updateLaunchinfo({
        commit
    }, data = {}) {
        commit(TYPES.UPDATE_LAUNCH_INFO, data);
    },
    //后台控制信息
    configInfo({
        commit
    }, data = {}) {
        commit(TYPES.CONFIG_INFO, data);
    },
	
    //登录状态
    loginStatus({
        commit
    }, loginStatus = {}) {
        commit(TYPES.LOGIN_STATUS, loginStatus);
    },
	
	//登录失败状态更新
	loginFaile({
	    commit
	}, loginFaile = {}) {
	    commit(TYPES.LOGIN_FAILE, loginFaile);
	},
	
    //版本控制
    isVersion({
        commit
    }, isVersion = {}) {
        commit(TYPES.ISVERSION, isVersion);
    },

    //用户设置
    userSetting({
        commit
    }, userSetting = {}) {
        commit(TYPES.USER_SETTING, userSetting);
    },
    //模板消息
    subscribe({
        commit
    }, subscribe = {}) {
        commit(TYPES.USER_SUBSCRIBE, subscribe);
    },
    

};

// mutations
const mutations = {
    [TYPES.UPDATE_USER_INFO](state, userinfo) {
        state.user = userinfo
    },
    [TYPES.UPPHONE](state, data) {
        state.user.user_info.phone = data
    },
    [TYPES.UPDATE_LAUNCH_INFO](state, launch) {
        state.launch = launch
    },
    [TYPES.SET_TOKEN](state, token) {
        state.token = token;
        AuthService.setToken(token);
    },
    [TYPES.SET_AUTH](state, user) {
        state.user = user;
        state.errors = {};
        AuthService.set(state.user);
    },
    //后端传回信息
    [TYPES.CONFIG_INFO](state, configInfo) {
        state.configInfo = configInfo
    },
    [TYPES.LOGIN_STATUS](state, loginStatus) {
        state.loginStatus = loginStatus
    },
    [TYPES.ISVERSION](state, isVersion) {
        state.isVersion = isVersion
    },
    [TYPES.BRAND_INFO](state, brandInfo) {
        state.brandInfo = brandInfo
    },
    [TYPES.USER_SETTING](state, userSetting) {
        state.userSetting = userSetting
    },
    [TYPES.USER_SUBSCRIBE](state, subscribe) {
        state.subscribe = subscribe
    },
    [TYPES.LOGIN_FAILE](state, loginFaile) {
        state.loginFaile = loginFaile
    },
};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
};
